// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"PaginationButtons_buttonsContainer__2iAtk","pageButton":"PaginationButtons_pageButton__1Lab7","active":"PaginationButtons_active__2suQS"};